import { axiosInstance } from '../axiosConfig';

export interface SucursalItem {
    id: number;
    nombre: string;
    direccion: string;
    codigo: string;
    telefono: string;
}

export interface CategoriaItem {
    id: number;
    nombre: string;
    descripcion: string;
}

export interface ServicioItem {
    id: number;
    nombre: string;
    descripcion: string;
    imagen: string | null;
    requiere_espacio: boolean;
    categoria_id: number;
    sucursales: number[];
}

export interface PrecioItem {
    id: number;
    servicio_id: number;
    plan_nombre: string;
    unidad: 'hora' | 'dia' | string;
    dias: number | null;
    horas: number | null;
    usa_temporizador: boolean;
    precio_inicial: number;
    precio_posterior: number | null;
    duracion_inicial: number | null;
}

export interface EspacioItem {
    id: number;
    espacio_id: number;
    espacio_nombre: string;
    espacio_descripcion: string;
    cantidad_personas: number;
    espacio_imagen: string | null;
    servicio_id: number;
    sucursal_id: number;
}

export interface CatalogoCotizacion {
    sucursales: SucursalItem[];
    categorias: CategoriaItem[];
    servicios: ServicioItem[];
    precios: PrecioItem[];
    espacios: EspacioItem[];
}

export interface CotizacionPayload {
    sucursal_id: number;
    servicio_id: number;
    precio_plan_servicio_id: number;
    espacio_servicio_id?: number | null;
    fecha_inicio: string;
    fecha_fin?: string;
    hora_inicio?: string;
    hora_fin?: string;
    cantidad_periodos: number;
    cupon_codigo?: string;
    nombre: string;
    apellido: string;
    email: string;
    telefono: string;
    ci_nit?: string;
    empresa?: string;
    observaciones?: string;
    personas?: number;
}

export interface CotizacionResponse {
    success: boolean;
    mensaje: string;
    cotizacion: {
        id: number;
        codigo: string;
        sucursal: string;
        servicio: string;
        espacio: string;
        fecha_inicio: string;
        fecha_fin: string;
        hora_inicio: string | null;
        hora_fin: string | null;
        cantidad_periodos: number;
        subtotal: number;
        descuento: number;
        total: number;
        cliente: {
            nombre: string;
            email: string;
            telefono: string;
            empresa: string;
        };
        whatsapp_url: string;
    };
}

export interface ReservaItem {
    id: number;
    fecha_inicio: string;
    fecha_fin: string;
    hora_inicio: string | null;
    hora_fin: string | null;
    estado: string;
    espacio_id?: number | null;
    espacio_nombre?: string | null;
}

export interface DisponibilidadResponse {
    hoy: string;
    reservas: ReservaItem[];
}

export const fetchCatalogoCotizacion = async (): Promise<CatalogoCotizacion> => {
    const response = await axiosInstance.get<CatalogoCotizacion>('cotizaciones/catalogo/');
    return response.data;
};

export const fetchDisponibilidad = async (params: {
    espacio_id?: number | null;
    espacio_servicio_id?: number | null;
    sucursal_id?: number | null;
    servicio_id?: number | null;
}): Promise<DisponibilidadResponse> => {
    const response = await axiosInstance.get<DisponibilidadResponse>('cotizaciones/disponibilidad/', { params });
    return response.data;
};

export const crearCotizacionPublica = async (payload: CotizacionPayload): Promise<CotizacionResponse> => {
    try {
        const response = await axiosInstance.post<CotizacionResponse>('cotizaciones/crear_cotizacion/', payload);
        return response.data;
    } catch (error: any) {
        const msg = error.response?.data?.error || error.response?.data?.detail || error.message || 'Error al generar la cotización';
        throw new Error(msg);
    }
};
